export const colors = {
  primary: "#0C3959",
  secondary: "#64C4B6",
  error: "#FF3333",
  navbarOption: "#FCFCFD",
};
